export const enum AdminRoles {
  // MAYBE LATER WE TO CHANGE THE NAME SUPER ADMIN BY JUST ADMIN
  Admin = "Admin",
  SuperAdmin = "SuperAdmin",
  Worker = "Worker"
}
